import * as yup from "yup"
import "yup-phone-lite"
import { Form, Textarea, File, Checkbox } from "components/Form"

export default function YourStoryForm({}) {
  const required = "This is required."
  const nameValidation = yup.string().required(required)

  const formConfig = {
    mode: "onChange",
    schema: yup.object().shape({
      Story: nameValidation,
      Consent: yup.string().min(10).required(required),
    }),
  }

  return (
    <div>
      <div className="px-5 lg:px-16">
        <h2 className="text-tertiary pb-4">Share Your Story</h2>
        <p className="text-gray-light pb-6">
          Over the past 25 years, we’ve witnessed an incredible evolution in how the government and federal employees
          meet their ever-shifting missions. Now, we want to hear your story. Share an experience that impacted your
          career or shaped your perspective as a federal employee during the last quarter-century.
        </p>

        <Form name="your-story" config={formConfig} gtmPrefix="share_story">
          <Textarea name="Story" label="Your Story 250 characters max" />
          <File name="File" label="BROWSE FILES..." type="file" />
          <Checkbox
            name="Consent"
            className=""
            useOwnError
            label=""
            options={["I agree this content may be used by FNN online and on social media."]}
          />
          <div className="flex justify-end">
            <button type="submit" className="primary-link self-end md:mr-8 z-[10000]">
              SHARE
            </button>
          </div>
        </Form>
      </div>
    </div>
  )
}
